import { merge } from "lodash-es";
import { sharedTranslations } from "../../shared-translations.js";

const algotelsSpecificTranslations = {
  "algotels-home-page": {
    title: "Always getting you </br> a better hotel deal",
    "top-destinations-title": "Top Destinations",
  },
  "html-metadata": {
    "brand-name": "Algotels",
  },
} as const;

export type IAlgotelsSpecificTranslations = typeof algotelsSpecificTranslations;

const algotelsTranslations = merge({}, sharedTranslations, algotelsSpecificTranslations);
export const translations = {
  dictionary: algotelsTranslations,
  language: "EN",
};
